import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";

import PublicLayout from "./components/PublicLayout";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./contexts/AuthContext";
import { ContentProvider } from "./contexts/ContentContext";
import { EditModeProvider } from "./contexts/EditModeContext";

import Home from "./pages/Home";
import Unternehmen from "./pages/Unternehmen";
import Kandidaten from "./pages/Kandidaten";
import UeberUns from "./pages/UeberUns";
import Kontakt from "./pages/Kontakt";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import AGB from "./pages/AGB";
import LeadConfirm from "./pages/LeadConfirm";
import LeadUnsubscribe from "./pages/LeadUnsubscribe";
import NotFound from "./pages/NotFound";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);
    return null;
}

const withLayout = (Page) => (
    <PublicLayout>
        <Page />
    </PublicLayout>
);

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <ContentProvider>
                    <EditModeProvider>
                        <BrowserRouter>
                            <ScrollToTop />
                            <Routes>
                                <Route path="/" element={withLayout(Home)} />
                                <Route path="/unternehmen" element={withLayout(Unternehmen)} />
                                <Route path="/kandidaten" element={withLayout(Kandidaten)} />
                                <Route path="/ueber-uns" element={withLayout(UeberUns)} />
                                <Route path="/kontakt" element={withLayout(Kontakt)} />
                                <Route path="/impressum" element={withLayout(Impressum)} />
                                <Route path="/datenschutz" element={withLayout(Datenschutz)} />
                                <Route path="/agb" element={withLayout(AGB)} />
                                <Route path="/lead-confirm" element={withLayout(LeadConfirm)} />
                                <Route path="/lead-unsubscribe" element={withLayout(LeadUnsubscribe)} />
                                <Route path="/admin/login" element={<AdminLogin />} />
                                <Route
                                    path="/admin"
                                    element={
                                        <ProtectedRoute>
                                            <AdminDashboard />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route path="*" element={withLayout(NotFound)} />
                            </Routes>
                            <Toaster position="top-right" richColors closeButton />
                        </BrowserRouter>
                    </EditModeProvider>
                </ContentProvider>
            </AuthProvider>
        </div>
    );
}

export default App;
